"use strict";

require("core-js/modules/esnext.global-this.js");
module.exports = function () {
  if (typeof globalThis !== "object") return false;
  if (!globalThis) return false;
  return globalThis.Array === Array;
};